import React, { useEffect, useState } from "react";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import { apiDeleteRequest } from "helpers/Requests";
import { notifyPendingLeaveChanged } from "helpers/pendingLeaveBadge";
import CustomButton from "components/common/Button/CustomButton";


const LeaveDeleteModal = (props) => {
  const [loading, setLoading] = useState(false);
  const {
    isShow,
    handleClose,
    leaveId,
    onDeleted,
    isUserGracePeriodOver,
    workerUuid,
  } = props;
  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });


  // useEffect(() => {
  //   if (leaveId) {
  //     console.log("Leave ID received in modal:", leaveId);
  //   }
  // }, [leaveId]);

  const handleDelete = async () => {
    if (!leaveId || !workerUuid) return;

    setRequest({ isRequested: true, isSuccess: false, isFailed: false });

    try {
      await apiDeleteRequest(
        `/sp/worker-leave/${leaveId}?worker_uuid=${workerUuid}`
      );
      setRequest({ isRequested: false, isSuccess: true, isFailed: false });
      notifyPendingLeaveChanged();

      if (onDeleted) onDeleted();
      handleClose();
    } catch (error) {
      console.error("Error deleting leave:", error);
      setRequest({ isRequested: false, isSuccess: false, isFailed: true });
    }
  };

  const modalFooter = () => (
    <>
      <CustomButton
        showLoading={request.isRequested}
        isDisabled={request.isRequested || isUserGracePeriodOver}
        label='Yes, delete Leave'
        clickHandler={handleDelete}
        variant='danger'
      />

      <CustomButton clickHandler={handleClose} label='No, cancel changes' />
    </>
  );
  return (
    <>
      {isShow && (
        <ModalSkeleton
          title='Delete Leave'
          cssClass='w-[50%]'
          isOpen={isShow}
          closeModal={handleClose}
          modalFooter={modalFooter()}
        >
          <p className='text-gray-700'>
            Are you sure you want to delete this leave? This action is
            irreversible.
          </p>
          <p className="text-xs text-gray-500 mt-2">This action will be recorded in the audit log.</p>
        </ModalSkeleton>
      )}
    </>
  );
};

export default LeaveDeleteModal;
